var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-icon-with-text",class:_vm.classObj},[_c('span',{staticClass:"-icon wticon",class:_vm.icon}),_vm._v(" "),(_vm.showText)?_c('span',{staticClass:"-caption"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }